import React, { useState } from 'react'
import { GridColDef } from '@mui/x-data-grid'
import { GridItem } from './gridItems'
import { EdifyMultiSelectButtonGroupAlt } from '../form/EdifyButtonGroup/EdifyMultiSelectButtonGroup'
import { ITransformedSubscription } from '../../pages/subscriptions/SubscriptionPageViewModel'

export const notificationOptions = [
  { name: 'Email', key: 'emailNotification' },
  { name: 'In-App', key: 'inAppNotification' },
  { name: 'Push', key: 'pushNotification' },
  { name: 'SMS', key: 'smsNotification' },
]

export const frequencyOptions = [
  { name: 'Instant', key: 'instant' },
  { name: 'Daily', key: 'daily' },
]

export const userFormNotificationReadColumns: GridColDef[] = [
  {
    field: 'formName',
    renderHeader: () => <GridItem text='Form Name' />,
    flex: 1,
    minWidth: 400,

    renderCell: ({ row }) => <GridItem text={row.formName} />,
  },
  {
    field: 'notificationType',
    renderHeader: () => <GridItem text='Notification Type' />,
    minWidth: 420,
    sortable: false,
    renderCell: ({ row }) => {
      const selections = []

      if (row.isPushEnabled) {
        selections.push('pushNotification')
      }
      if (row.isEmailEnabled) {
        selections.push('emailNotification')
      }
      if (row.isInAppEnabled) {
        selections.push('inAppNotification')
      }
      if (row.isSmsEnabled) {
        selections.push('smsNotification')
      }

      const [selectedNotificationTypes, setSelectedNotificationTypes] = React.useState<string[]>(selections) // Start empty - component will auto-select first option

      return (
        <EdifyMultiSelectButtonGroupAlt
          disabled={row.readonly}
          buttonGroup={notificationOptions}
          selectedButtons={selectedNotificationTypes}
          setSelectedButtons={setSelectedNotificationTypes}
        />
      )
    },
  },
  {
    field: 'subscriptionType',
    renderHeader: () => <GridItem text='Notification Frequency' />,
    width: 190,
    renderCell: ({ row }) => <GridItem text={row.subscriptionType} />,
  },
]

export const normalizeFormNotificationForReadDataGrid: any = (
  userFormNotificationXs?: ITransformedSubscription[],
  readonly?: boolean,
  showAll?: boolean,
  handleAddCB?: any,
) => {
  if (!userFormNotificationXs) return []

  return userFormNotificationXs?.map((userFormNotificationX: ITransformedSubscription, i) => {
    return {
      id: userFormNotificationX.formId,
      formName: userFormNotificationX.formName,
      isSmsEnabled: userFormNotificationX.isSmsEnabled,
      isEmailEnabled: userFormNotificationX.isEmailEnabled,
      isPushEnabled: userFormNotificationX.isPushEnabled,
      isInAppEnabled: userFormNotificationX.isInAppEnabled,
      formId: userFormNotificationX.formId,
      readonly: readonly ? true : false,
      showAll: showAll ? true : false,
      handleAddCB: handleAddCB,
      subscriptionType: userFormNotificationX.subscriptionType,
    }
  })
}
